const styles = theme => ({
  title: {
    margin: theme.spacing(3, 0),
    textAlign: 'center',
    color: theme.typography.body2.color,
  },
  plansContainer: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  plan: {
    margin: `${theme.spacing(3) / 2}px 0px`,
    [theme.breakpoints.up('sm')]: {
      width: '290px',
      margin: `${theme.spacing(3) / 2}px 7px`,
    },
  },
  progress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 0),
  },
  notFound: {
    padding: theme.spacing(4, 0),
  },
  subscribeButton: {
    marginBottom: theme.spacing(1),
  },
})

export default styles
